import { Component, computed, effect, Input, OnInit, signal, Signal, WritableSignal } from '@angular/core';
import { RekbotSettingsOpenHours } from '../../models/rekbot-settings-open-hours.model';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AbstractControl, FormControl, FormsModule, ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import {ErrorStateMatcher} from '@angular/material/core';
import { Observable, Subject, timeout } from 'rxjs';
import { NgIf } from '@angular/common';


@Component({
    selector: 'app-rekbot-day-open-hours',
    standalone: true,
    imports: [
        NgIf,
        MatSlideToggleModule,
        MatFormFieldModule,
        FormsModule,
        MatInputModule
    ],
    templateUrl: './rekbot-day-open-hours.component.html',
    styleUrl: './rekbot-day-open-hours.component.css'
})


export class RekbotDayOpenHoursComponent implements OnInit  {

  public validFrom: boolean = true;
  public validTo: boolean = true;

  public validToSignal: Signal<boolean> = computed(() => {
    // console.log("compute ValidTosignal", this.validTo)
    return this.validTo;
  } );

  public validFromSignal: WritableSignal<boolean> = signal(false);

  public validFromSubject = new Subject<boolean>();
  public validToSubject = new Subject<boolean>();

  public errorStateChanged = new Subject<boolean>();

  //public timeValidator(form: AbstractControl): ValidationErrors | null {
  public timeValidator(): ValidationErrors | null {

    const timeFrom = this.settingsOpenHours.open_time
    const timeTo = this.settingsOpenHours.close_time

    const isValidTimeFrom = this.isValidTime(timeFrom)
    const isValidTimeTo = this.isValidTime(timeTo)

    // console.log("validate Time timeValidator")

    if(!isValidTimeFrom) {
      alert("Popraw czas timeValidator");
    }

    if(!isValidTimeTo) {
      alert("Popraw czas");
    }


    return (!isValidTimeFrom || !isValidTimeTo) ? null : { timeValidationError: true };
    //return password === password_confirmation ? null : { passwordMismatchError: true };
  }


  public disabled:boolean = false;

  @Input() settingsOpenHours: RekbotSettingsOpenHours = {
    id:null, 
    rekbot_id: null, 
    day: 0, 
    open: 0, 
    open_time: "00:00",
    close_time: "00:00"
  };

  //@Input() timeValidationErrors: boolean = false
  @Input() timeValidationErrors: Array<Signal<boolean>> = [signal(false), signal(false)];

  public days = [
    {
      id:1, 
      name: "Pon"
    }, 
    {
      id: 2, 
      name: "Wt"
    },
    {
      id: 3,
      name: "Śr"
    },
    {
      id: 4,
      name: "Czw"
    },
    {
      id: 5,
      name: "Pt"
    },
    {
      id: 6,
      name: "So",

    },
    {
      id: 7,
      name: "Ni"

    }
    
  ];

  constructor() {

    /*effect(() => {
      console.log(`The current signal is: ${this.validToSignal()}`);
    });*/
  
  }

  isValidTime(str?: string|null) {

    // Regex to check valid
    // time in 24-hour format
    let regex = new RegExp(/^([01]\d|2[0-3]):?([0-5]\d)$/);
 
    //  if str 
    // is empty return false
    if (str == null) {
        return false;
    }
 
    // Return true if the str
    // matched the ReGex
    if (regex.test(str) == true) {
        return true;
    }
    else {
        return false;
    }
  }

  isValidFrom() {
    return !this.validFrom;
  }

  isValidTo() {
    return !this.validTo;
  }


  testFromValidation() {
    this.validFrom = this.isValidTime(this.settingsOpenHours.open_time)

    // console.log("testFromValidation", this.validFrom)

    this.timeValidationErrors[0] = signal(this.validFrom)

    return !this.validFrom
  }

  testToValidation() {

    this.validTo = this.isValidTime(this.settingsOpenHours.close_time)
     //= validTime
    // console.log("testToValidation", this.validTo)

    this.timeValidationErrors[1] = signal(this.validTo)

    return !this.validTo
  }

 
  ngOnInit() {

    // console.log("ngOnInit", this.timeValidationErrors[0](), this.timeValidationErrors[1]());

    setTimeout(()=> {

      this.testFromValidation();
      this.testToValidation();
  
    }, 2000);

  }



}
